import React, { useState, useEffect } from "react";
import "./App.css";
import "./styles/wallpaper.css"; 
import CustomModal from "./CustomModal"; 
import Order from "./Order";             
import Community from "./pages/Community"; 
import Profile from "./pages/Profile";     
import AdminDashboard from "./pages/AdminDashboard"; // 👑 总统大屏
import axios from "axios";                 
import io from "socket.io-client";          
import PaymentModal from './PaymentModal'; 

const IS_UNDER_REVIEW = false;

const allProducts = {
  "热狗": [
    { 
      id: 1, en: "CLASSIC", cn: "经典美式", price: 16, 
      desc: "经典美式风味的完整复刻，黄油脆底面包，纯肉肠与酱料三重黄金组合。", 
      ing: "黄油面包 · 纯肉肠 · 清爽蔬果", 
      options: [{ title: "酱料选择", choices: ["正常酱", "少酱", "多酱"] }, { title: "配料调整", choices: ["标准", "不要生菜", "不要番茄"] }] 
    },
    { 
      id: 2, en: "CORN CHEESE", cn: "芝士玉米", price: 22, 
      desc: "芝士融化成黄金熔岩，包裹玉米双重芝士与柠檬酱的独家搭配。", 
      ing: "双倍芝士 · 甜玉米粒 · 酥香海苔", 
      options: [{ title: "酱料选择", choices: ["正常酱", "少酱", "多酱"] }, { title: "配料调整", choices: ["标准", "不要生菜"] }] 
    },
    { 
      id: 3, en: "NYC BEEF RAGU", cn: "纽约肉酱", price: 24, 
      desc: "满满手作牛肉酱的扎实满足，搭配酸黄瓜脆爽，风味层叠如都市繁华。", 
      ing: "厚重牛肉酱 · 独家泡菜 · 奇异芥香", 
      options: [{ title: "酱料选择", choices: ["正常酱", "少酱", "多酱"] }, { title: "选择泡菜", choices: ["红烩甜椒", "莳萝黄瓜", "山椒娃娃菜", "不要泡菜"] }] 
    },
    { 
      id: 4, en: "TEXAN BBQ", cn: "德州烤肉", price: 24, 
      desc: "豪迈自制烟熏烧烤酱的粗犷体验，酥脆牛蒡丝与流心芝酱形成绝妙搭配。", 
      ing: "培根烧烤酱 · 牛蒡丝 · 威士忌香", 
      options: [{ title: "酱料选择", choices: ["正常酱", "少酱", "多酱"] }, { title: "选择泡菜", choices:  ["红烩甜椒", "莳萝黄瓜", "山椒娃娃菜", "不要泡菜"] }] 
    }
  ],
  "小食": [], "饮品": [], "套餐": []  
};

function App() {
  const [isPayModalOpen, setIsPayModalOpen] = useState(false);
  const [currentTotal, setCurrentTotal] = useState(0);
  const [activeCategory, setActiveCategory] = useState("热狗");
  const [activeTab, setActiveTab] = useState("菜单");
  const [selectedProduct, setSelectedProduct] = useState(null);
  
  const [cart, setCart] = useState([]);
  const [orderStatus, setOrderStatus] = useState("cart");
  const [socket, setSocket] = useState(null);
  
  const [zoomedCard, setZoomedCard] = useState(null);
  
  // 👑 总统大屏秘密状态
  const [showAdminDashboard, setShowAdminDashboard] = useState(false);
  const [logoClickCount, setLogoClickCount] = useState(0);
  const [adminSecret, setAdminSecret] = useState(process.env.REACT_APP_ADMIN_SECRET || 'funky-admin-2024');
  
  const [activeOrders, setActiveOrders] = useState(() => {
    const saved = localStorage.getItem('funky_dog_orders');
    return saved ? JSON.parse(saved) : [];
  }); 
  const [showTracker, setShowTracker] = useState(false);

  const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

  // 🔐 秘密入口逻辑：点击招牌5次激活总统大屏
  useEffect(() => {
    const timer = setTimeout(() => {
      setLogoClickCount(0); // 3秒内重置计数
    }, 3000);

    if (logoClickCount >= 5) {
      setShowAdminDashboard(true);
      setLogoClickCount(0);
      console.log('👑 总统大屏秘密入口已激活！');
    }

    return () => clearTimeout(timer);
  }, [logoClickCount]);

  // 🔍 URL参数秘密入口：?mode=boss
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const mode = urlParams.get('mode');
    if (mode === 'boss') {
      setShowAdminDashboard(true);
      console.log('👑 总统大屏URL入口已激活！');
    }
  }, []);

  const handleLogoClick = () => {
    setLogoClickCount(prev => prev + 1);
  };

  useEffect(() => {
    localStorage.setItem('funky_dog_orders', JSON.stringify(activeOrders));
  }, [activeOrders]);

  // 🚀 核心升级：静默雷达现在拥有“自动清理幽灵数据”的能力
  useEffect(() => {
    const fetchLatestStatus = async () => {
      if (activeOrders.length === 0) return;
      try {
        const res = await axios.get(`${API_BASE_URL}/orders`);
        const allDbOrders = res.data; 
        
        setActiveOrders(prev => {
          let hasChanges = false;
          // 过滤掉那些在后台已经被彻底删除的脏数据
          const validOrders = prev.filter(localOrder => {
            const existsInDb = allDbOrders.some(o => o.id === localOrder.id);
            if (!existsInDb) hasChanges = true; // 如果后台没了，本地就得清理
            return existsInDb;
          });

          const updatedOrders = validOrders.map(localOrder => {
            const dbOrder = allDbOrders.find(o => o.id === localOrder.id);
            if (dbOrder && dbOrder.status !== localOrder.status) {
              hasChanges = true;
              return { ...localOrder, status: dbOrder.status }; 
            }
            return localOrder;
          });

          return hasChanges ? updatedOrders : prev;
        });
      } catch (e) { console.log("静默雷达扫描失败"); }
    };

    const timer = setInterval(fetchLatestStatus, 3000); 
    return () => clearInterval(timer);
  }, [activeOrders.length, API_BASE_URL]);

  useEffect(() => {
    const newSocket = io(process.env.REACT_APP_SOCKET_URL || "http://localhost:5000");
    setSocket(newSocket);
    newSocket.on('order_status_update', (data) => {
      setActiveOrders(prevOrders => prevOrders.map(o => o.id === data.order_id ? { ...o, status: data.status } : o));
    });
    return () => newSocket.close();
  }, []);

  const submitOrder = async (orderData) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/orders`, orderData);
      return response.data;
    } catch (error) { throw error; }
  };

  const handleClearAllRecords = async () => {
    if (window.confirm("🚨 确定要清空所有订单记录吗？后台和大屏数据也将被同步抹除！")) {
      try {
        await axios.delete(`${API_BASE_URL}/orders/debug/clear-all`);
        setActiveOrders([]); 
        localStorage.removeItem('funky_dog_orders'); 
        setShowTracker(false); 
        alert("💥 测试记录已全网清空！");
      } catch (error) { alert("清理失败，请检查后端网络！"); }
    }
  };

  const handleAddToCart = (selections) => {
    setCart([...cart, { ...selectedProduct, selections }]);
    setSelectedProduct(null); 
  };

  const renderMenu = () => {
    const products = allProducts[activeCategory] || [];
    if (products.length === 0) return (<div className="empty-state"><h2>🚧 【{activeCategory}】领地暂无产品</h2></div>);
    
    return (
      <div style={{ position: 'relative' }}>
        <div className="card-grid">
          {products.map((item) => (
            <div 
              key={item.id} 
              className={`poster-card ${zoomedCard === item.id ? 'is-zoomed' : ''}`}
              onClick={() => setZoomedCard(zoomedCard === item.id ? null : item.id)} 
            >
              <div className="image-box"></div>
              <div className="info-box">
                <div className="title-area">
                  <div className="en">{item.en}</div>
                  <div className="cn-price-row">
                    <span className="cn">{item.cn}</span>
                    {!IS_UNDER_REVIEW && <span className="price">¥{item.price}</span>}
                  </div>
                </div>
                <div className="divider"></div>
                <div className="desc">{item.desc}</div>
                <div className="ingredients">{item.ing}</div>
                {!IS_UNDER_REVIEW && (
                  <button 
                    className="add-btn" 
                    onClick={(e) => {
                      e.stopPropagation(); 
                      setSelectedProduct(item); 
                      setZoomedCard(null); 
                    }}
                  >
                    加入
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>

        {zoomedCard && (
          <div 
            style={{
              position: 'fixed',
              top: 0, left: 0, right: 0, bottom: 0,
              background: 'rgba(0,0,0,0.6)',
              zIndex: 999, 
              backdropFilter: 'blur(3px)'
            }} 
            onClick={() => setZoomedCard(null)} 
          />
        )}
      </div>
    );
  };

  const formatSelections = (selections) => {
    if (!selections) return "标准配方";
    if (typeof selections === 'string') return selections;
    return Object.values(selections).join('，'); 
  };

  // 白名单机制：绝对精准分离
  const ongoingOrders = activeOrders.filter(o => {
    const s = (o.status || '').toUpperCase();
    return ['PENDING', 'MAKING', 'DONE'].includes(s); 
  });
  
  const completedOrders = activeOrders.filter(o => {
    const s = (o.status || '').toUpperCase();
    return s === 'COMPLETED';
  });

  const getDynamicTrackerBtn = () => {
    // 1. 已出餐待取餐
    if (ongoingOrders.some(o => (o.status || '').toUpperCase() === 'DONE')) return { text: "✅ 待取餐", bg: "#4CAF50", color: "#fff" };
    // 2. 制作中
    if (ongoingOrders.some(o => (o.status || '').toUpperCase() === 'MAKING')) return { text: "🔥 制作中", bg: "#E6B422", color: "#000" };
    // 3. 等待制作 (顾客已付，等待后厨点开始)
    if (ongoingOrders.some(o => (o.status || '').toUpperCase() === 'QUEUING')) return { text: "⏳ 等待制作", bg: "#fff", color: "#000" };
    // 4. 待付款 (顾客刚下单，未支付)
    if (ongoingOrders.some(o => (o.status || '').toUpperCase() === 'PENDING')) return { text: "💳 待付款", bg: "#ff5252", color: "#fff" };
    
    // 💥 即使没有单子，雷达也绝不消失，留作历史入口！(已改回纯白底色)
    return { text: "📜 订单档案", bg: "#fff", color: "#000", isHistory: true }; 
  };

  const trackerBtnStyle = getDynamicTrackerBtn();

  return (
    <div className="App wallpaper-container">
      <div className="wallpaper-overlay"></div>
      <div className="hero-banner" onClick={handleLogoClick} style={{ cursor: 'pointer' }}></div> {/* 👑 点击5次激活总统大屏 */}
      <div className="layout">
        
        {activeTab === "菜单" && (
          <div className="sidebar">
            {Object.keys(allProducts).map((cat) => (
              <button key={cat} className={`side-btn ${activeCategory === cat ? "active" : ""}`} onClick={() => { setActiveCategory(cat); setActiveTab("菜单"); }}>
                {cat}
              </button>
            ))}
          </div>
        )}
        
        <div className="order-area" style={{ paddingBottom: '80px' }}>
          {activeTab === "菜单" && renderMenu()}
          {activeTab === "订单" && (
            <Order cart={cart} setCart={setCart} orderStatus={orderStatus} setOrderStatus={setOrderStatus} socket={socket} submitOrder={submitOrder} openPayModal={(total) => { setCurrentTotal(total); setIsPayModalOpen(true); }} />
          )}
          {activeTab === "社区" && <Community />}
          {activeTab === "我的" && <Profile />}
        </div>
      </div>

     {/* 🚁 缩小状态：左下角胶囊雷达 */}
      {/* 💥 核心修改：战时雷达全站显示，但没单子时的“订单档案”仅在“订单”页面(activeTab==="订单")显影 */}
      {trackerBtnStyle && !showTracker && (!trackerBtnStyle.isHistory || activeTab === "订单") && (
        <div onClick={() => setShowTracker(true)} style={{ position: "fixed", bottom: "110px", left: "15px", zIndex: 999, background: trackerBtnStyle.bg, color: trackerBtnStyle.color, padding: "10px 20px", borderRadius: "30px", border: "3px solid black", boxShadow: "4px 4px 0 rgba(0,0,0,1)", fontWeight: "900", cursor: "pointer", display: "flex", alignItems: "center", gap: "8px", fontSize: "14px", animation: ongoingOrders.length > 0 ? "pulse 2s infinite" : "none" }}>
          {trackerBtnStyle.text}
          {/* 💥 核心修改：如果是历史订单档案（没有进行中的订单），则隐藏数字角标 */}
          {!trackerBtnStyle.isHistory && (
            <span style={{ background: trackerBtnStyle.bg === '#000' || trackerBtnStyle.bg === '#4CAF50' ? 'white' : 'black', color: trackerBtnStyle.bg === '#000' || trackerBtnStyle.bg === '#4CAF50' ? 'black' : 'white', borderRadius: "50%", padding: "2px 6px", fontSize: "12px" }}>
              {ongoingOrders.length}
            </span>
          )}
        </div>
      )}

      {/* 🗄️ 展开状态：历史与当前订单双区面板 */}
      {showTracker && (
        <div style={{ position: "fixed", bottom: "105px", left: "15px", right: "15px", zIndex: 1000, background: "white", border: "4px solid black", borderRadius: "10px", boxShadow: "8px 8px 0 rgba(0,0,0,1)", display: "flex", flexDirection: "column", maxHeight: "65vh", overflow: "hidden" }}>
          <div style={{ background: "#f0f0f0", padding: "15px", display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "3px solid black" }}>
            <span style={{ fontWeight: "900", fontSize: "18px" }}>📜 我的订单档案</span>
            <button onClick={() => setShowTracker(false)} style={{ background: "black", color: "white", border: "none", padding: "5px 10px", fontWeight: "bold", borderRadius: "5px" }}>关闭 ⬇</button>
          </div>
          
          <div style={{ padding: "15px", overflowY: "auto", flex: 1, background: "#fafafa" }}>
            {ongoingOrders.length > 0 && (
              <>
                <div style={{ fontWeight: "900", fontSize: "16px", marginBottom: "10px", borderBottom: "2px solid #ccc", paddingBottom: "5px" }}>🔥 进行中 ({ongoingOrders.length})</div>
                {ongoingOrders.slice().reverse().map(order => (
                  <div key={order.id} style={{ border: "3px solid black", background: "white", padding: "15px", marginBottom: "15px", boxShadow: "3px 3px 0 #000", position: "relative" }}>
                    <div style={{ position: "absolute", top: "-12px", right: "-10px", background: order.status === 'DONE' ? "#4CAF50" : order.status === 'MAKING' ? "#E6B422" : "#ccc", color: order.status === 'DONE' ? "white" : "black", padding: "4px 12px", fontWeight: "900", border: "2px solid black", transform: "rotate(5deg)" }}>
                      {order.status === 'DONE' ? '✅ 可取餐' : order.status === 'MAKING' ? '🔥 制作中' : '🕒 待处理'}
                    </div>
                    <div style={{ fontWeight: "900", fontSize: "16px", marginBottom: "8px" }}>单号：#{order.id}</div>
                    <div style={{ fontSize: "13px", color: "#444", borderTop: "1px dashed #ccc", paddingTop: "8px", paddingBottom: "8px" }}>
                      {order.items ? JSON.parse(order.items).map((item, i) => (
                        <div key={i}>• {item.name} x {item.quantity} {item.customization !== "标准配方" && <span style={{color:"#ff5252"}}>({item.customization})</span>}</div>
                      )) : "产品明细加载中..."}
                    </div>
                    <div style={{ textAlign: "right", fontWeight: "900", fontSize: "18px", color: "#E85A33" }}>¥{order.total_amount}</div>
                  </div>
                ))}
              </>
            )}

            {completedOrders.length > 0 && (
              <>
                <div style={{ fontWeight: "900", fontSize: "16px", marginTop: "20px", marginBottom: "10px", borderBottom: "2px solid #ccc", paddingBottom: "5px", color: "#666" }}>🗄️ 历史归档 ({completedOrders.length})</div>
                {completedOrders.slice().reverse().map(order => (
                  <div key={order.id} style={{ border: "3px solid #666", background: "#eaeaea", padding: "15px", marginBottom: "15px", position: "relative", opacity: 0.9 }}>
                    <div style={{ position: "absolute", top: "-12px", right: "-10px", background: "#000", color: "white", padding: "4px 12px", fontWeight: "900", border: "2px solid black", transform: "rotate(5deg)" }}>
                      🎉 已交接
                    </div>
                    <div style={{ fontWeight: "900", fontSize: "16px", marginBottom: "8px", color: "#444" }}>历史单号：#{order.id}</div>
                    <div style={{ fontSize: "13px", color: "#666", borderTop: "1px dashed #ccc", paddingTop: "8px", paddingBottom: "8px" }}>
                      {order.items ? JSON.parse(order.items).map((item, i) => (
                        <div key={i}>• {item.name} x {item.quantity}</div>
                      )) : "数据"}
                    </div>
                    <div style={{ marginTop: "10px", background: "black", color: "white", padding: "12px", textAlign: "center", border: "2px solid #E6B422", borderRadius: "4px" }}>
                      <div style={{ fontSize: "16px", fontWeight: "900", marginBottom: "4px" }}>🎉 餐已完成，谢谢惠顾！</div>
                      <div style={{ fontSize: "12px", color: "#E6B422", fontWeight: "bold" }}>欢迎再次回到放克社区</div>
                    </div>
                  </div>
                ))}
              </>
            )}
            
            <button onClick={handleClearAllRecords} style={{ width: "100%", marginTop: "15px", background: "#ff5252", color: "white", padding: "12px", border: "3px solid black", fontWeight: "900", cursor: "pointer", boxShadow: "2px 2px 0 #000" }}>
              💥 清空全服测试订单
            </button>
          </div>
        </div>
      )}
      
      <div className="bottom-nav" style={{ zIndex: 1100, position: "fixed", bottom: 0, width: "100%" }}>
        {["菜单", "订单", "社区", "我的"].map((tab) => (
          <button key={tab} className={activeTab === tab ? "active" : ""} onClick={() => setActiveTab(tab)} style={{ position: "relative" }}>
            {tab}
            {tab === "订单" && cart.length > 0 && (
              <span style={{ position: "absolute", top: "8px", right: "20%", background: "#E85A33", color: "#FFF", fontSize: "12px", fontWeight: "900", padding: "2px 6px", borderRadius: "50%", border: "2px solid #000", boxShadow: "2px 2px 0 #000", lineHeight: "1" }}>
                {cart.length}
              </span>
            )}
          </button>
        ))}
      </div>

      {selectedProduct && <CustomModal product={selectedProduct} onClose={() => setSelectedProduct(null)} onConfirm={handleAddToCart} />}
      
      {isPayModalOpen && (
        <PaymentModal 
          total={currentTotal} 
          onConfirm={async (payMethod) => { 
            const formattedItems = cart.map(item => ({ name: item.cn, quantity: item.count || 1, customization: formatSelections(item.selections) }));
            try {
              const newOrder = await submitOrder({ items: formattedItems, total_amount: currentTotal, status: 'PENDING', pay_method: payMethod });
              setIsPayModalOpen(false);
              setCart([]); 
              setOrderStatus("cart"); 
              setActiveTab("菜单"); 
              setActiveOrders(prev => [...prev, newOrder]); 
              setShowTracker(false); 
            } catch (e) { alert("通讯失败！"); }
          }} 
          onClose={() => setIsPayModalOpen(false)} 
        />
      )}

      {/* 👑 总统大屏 - 秘密监控台 */}
      {showAdminDashboard && (
        <AdminDashboard 
          onClose={() => setShowAdminDashboard(false)}
          adminSecret={adminSecret}
        />
      )}
    </div>
  );
}

export default App;